export default __webpack_public_path__ + "static/media/trash.45499677.svg";